import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import "./scheduler.css";

// The one shared date-navigation cluster used by both the Calendar screen (SchedulerTest.jsx)
// and Termini (TimeslotsSection.js), instead of two separate hand-rolled implementations that
// only looked similar. Reuses Calendar's own existing classes verbatim (`.hf-cal-m-*`/
// `.hf-cal-nav-icon-btn`/`.hf-cal-today-btn`, still defined in scheduler.css) rather than new
// CSS, so icons/typography/spacing/hover states are guaranteed identical, not just visually
// matched. `variant` mirrors Calendar's own existing split — "mobile" (prev / tap-range-for-
// today / next, no separate Today button) or "desktop" (prev / Today button / next) — the
// caller picks which one to render via its own existing breakpoint check, same as Calendar
// already does for itself.
const CalendarWeekNav = ({ variant, label, todayLabel, onPrev, onNext, onToday }) => {
  if (variant === "mobile") {
    return (
      <div className="hf-cal-m-header">
        <button
          type="button"
          className="hf-cal-m-nav-btn"
          onClick={onPrev}
          aria-label="Prethodni period"
        >
          <ArrowBackIosIcon fontSize="small" />
        </button>
        <button
          type="button"
          className="hf-cal-m-range"
          onClick={onToday}
          aria-label="Idi na danas"
        >
          {label}
        </button>
        <button
          type="button"
          className="hf-cal-m-nav-btn"
          onClick={onNext}
          aria-label="Sledeći period"
        >
          <ArrowForwardIosIcon fontSize="small" />
        </button>
      </div>
    );
  }

  return (
    <div className="hf-calnav-desktop">
      <button
        type="button"
        className="hf-cal-nav-icon-btn"
        onClick={onPrev}
        aria-label="Prethodni period"
      >
        <ArrowBackIosIcon fontSize="small" />
      </button>
      {/* `todayLabel` overrides this button's text (e.g. PackageManagement's own month name)
          without touching `label` — Calendar/Termini both already pass `label` here too (their
          own week range), but only "mobile" renders it; this button staying "Danas" by default
          keeps their desktop nav identical to before. */}
      <button type="button" className="hf-cal-today-btn" onClick={onToday}>
        {todayLabel || "Danas"}
      </button>
      <button
        type="button"
        className="hf-cal-nav-icon-btn"
        onClick={onNext}
        aria-label="Sledeći period"
      >
        <ArrowForwardIosIcon fontSize="small" />
      </button>
    </div>
  );
};

export default CalendarWeekNav;
